import CaptchaWidget from "@/UI/CaptchaWidget/CaptchaWidget";
import React, { useState } from "react";
import { Loader } from "rsuite";
import { useResetPasswordMutation } from "../../../../Store/APIs/Auth.api";
import BasicAuthInput from "../../../../UI/BasicAuthInput";
import BasicButton from "../../../../UI/BasicButton";
import { validateEmail } from "../../../AuthPage/Helpers/ValidationHelpers";
import {
  ForgotButtonsBlock,
  ForgotEmailIcon,
  ForgotError,
  ForgotFootnote,
  ForgotThanksBlock,
  ForgotThanksText,
  ForgotTitle,
  ForgotTitleBlock,
  ForgotWindow,
} from "../../styled";

interface ISendEmailWindowProps {
  handleReturn: () => void;
}

const SendEmailWindow: React.FC<ISendEmailWindowProps> = ({ handleReturn }) => {
  const [emailValue, setEmailValue] = useState("");
  const [emailFieldError, setEmailFieldError] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState("");

  const [sendEmail, { isLoading }] = useResetPasswordMutation();

  const handleSetEmailValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmailFieldError(false);
    setError("");
    setEmailValue(event.target.value);
  };

  const handleSendEmail = () => {
    const isValidEmail = validateEmail(emailValue);

    if (emailValue.length && isValidEmail && captchaToken) {
      sendEmail({ login: emailValue, token: captchaToken }).then((result) => {
        if ("data" in result) {
          setEmailSent(true);
        }
      });
    } else {
      if (!isValidEmail) setEmailFieldError(true);
      else setError("Please complete the security check");
    }
  };

  return (
    <>
      {!emailSent ? (
        <ForgotWindow>
          <ForgotTitleBlock>
            <ForgotTitle>Forgot password</ForgotTitle>
            <ForgotFootnote>Enter your email to reset password</ForgotFootnote>
          </ForgotTitleBlock>
          <BasicAuthInput
            fieldType={"email"}
            fieldError={emailFieldError}
            value={emailValue}
            onChange={handleSetEmailValue}
            placeholder={"E-mail"}
            type={"text"}
            errorText={"Incorrect email"}
          />
          <ForgotButtonsBlock>
            <CaptchaWidget onVerify={setCaptchaToken} />
            <BasicButton
              onClick={handleSendEmail}
              size={"lg"}
              text={"Submit"}
              variant={"blue"}
            />
            <BasicButton
              onClick={handleReturn}
              size={"lg"}
              text={"Back"}
              variant={"white"}
            />
            <ForgotError>{error}</ForgotError>
          </ForgotButtonsBlock>
          {isLoading && (
            <Loader backdrop size="lg" content="Sending..." vertical />
          )}
        </ForgotWindow>
      ) : (
        <ForgotWindow>
          <ForgotThanksBlock>
            <ForgotTitle>Thank you!</ForgotTitle>
            <ForgotEmailIcon />
            <ForgotThanksText>
              Your message has been sent, please check your email
            </ForgotThanksText>
          </ForgotThanksBlock>
          <BasicButton
            onClick={handleReturn}
            size={"lg"}
            text={"OK"}
            variant={"blue"}
          />
        </ForgotWindow>
      )}
    </>
  );
};

export default SendEmailWindow;
